import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { toggleGlobalSearchVisibility } from '../../store/modules/interfaces/actions';
import {
  updateSearchTerm,
  updateSearchHint,
  updateSearchResultsCorrected
} from '../../store/modules/user/actions';

export const Search = (Component) => (props) => (
  <Component {...props} />
);

const mapStateToProps = (state) => ({
  activeMini: state.petites?.active_mini,
  isGlobalSearchActive: state.interfaces.isGlobalSearchActive,
  areSearchResultsCorrected: state.user.areSearchResultsCorrected,
  globalSearchTerm: state.user.searchTerm,
  globalSearchHint: state.user.searchHint,
  petites: state.petites
});

const mapDispatchToProps = (dispatch) => ({
  toggleGlobalSearchVisibility: (isActive) => dispatch(toggleGlobalSearchVisibility(isActive)),
  updateSearchTerm: (term) => dispatch(updateSearchTerm(term)),
  updateSearchHint: (hint) => dispatch(updateSearchHint(hint)),
  updateSearchResultsCorrected: (flag) => dispatch(updateSearchResultsCorrected(flag))
});

export default compose(connect(mapStateToProps, mapDispatchToProps), Search);
